import { Store } from 'src/store/index';

const getProductUid = (store: Store) => store.design.productUid;

export default getProductUid;
